module.exports = __webpack_public_path__ + "assets/img/nuosavas-namas-elektrine-slaitiniam-stogui.151269bc.jpg";